import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { ApiConstant, LangConstant } from "const";
import { ApiUtils, HumpUtils, SystemUtils } from "utils";
import qs from "qs";
import useInvalidateQueries from "hooks/common/useInvalidateQueries";

export default function useUpdateAppConfig() {
  const { t: getLabel } = useTranslation();

  const { invalidateServiceQueries } = useInvalidateQueries();

  const updateAppConfigMutation = useMutation({
    mutationFn: async data => {
      const response = await ApiUtils.createApiWithToken(false).post(
        ApiConstant.UPDATE_SERVER_CONFIG,
        qs.stringify(HumpUtils.decamelizeKeys(data)),
      );
      return response.data;
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async (response, data) => {
      if (response.status === ApiConstant.STT_OK) {
        await invalidateServiceQueries();
        SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_SUCCESS), "success");
      } else {
        SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
      }
    },
    onError: error => {
      console.error(error);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
    },
  });

  const updateAppConfigAsync = async payload => {
    return updateAppConfigMutation.mutateAsync(payload);
  };

  return { updateAppConfigAsync };
}
